<template>
  <div class="nuevo-miembro-page">
    <div class="bg-grid" aria-hidden="true"></div>

    <div class="nuevo-miembro-shell">
      <!-- Header -->
      <header class="page-header fade-in">
        <h1 class="page-title">Registrar miembro</h1>
        <breadcrumbs
          :items="[
            { text: 'Inicio', href: '/' },
            { text: 'Miembros', href: '/#/miembros' }
          ]"
        />
      </header>

      <!-- Form Content -->
      <section class="fade-in delay-100">
        <form-miembro :miembro="datosMiembro" @registrado="onRegistrado" />
      </section>
    </div>

    <!-- Dialog: Miembro Registrado -->
    <v-dialog v-model="mostrarMiembroRegistrado" persistent max-width="480">
      <div class="modal-panel">
        <div class="modal-head modal-head-success">
          <div class="modal-status-icon">
            <v-icon size="26" color="#0E0E10">mdi-check</v-icon>
          </div>
          <h3 class="modal-title">Miembro registrado</h3>
        </div>

        <div class="modal-body">
          <p class="modal-text-center">
            El miembro con matrícula
            <strong class="text-accent">{{ matricula }}</strong> ha sido
            registrado exitosamente.
          </p>

          <div class="info-box">
            <v-icon size="16" class="mr-2" color="#8C8C93"
              >mdi-information-outline</v-icon
            >
            Puede pagar la membresía en este momento o al realizar la primera
            visita.
          </div>
        </div>

        <div class="modal-footer modal-footer-stack">
          <button class="btn-primary" @click="realizarPago">
            <v-icon size="15" class="mr-2">mdi-cash</v-icon>
            Realizar pago
          </button>
          <button class="btn-ghost" @click="generarCredencial">
            <v-icon size="15" class="mr-2">mdi-card-account-details</v-icon>
            Generar credencial
          </button>
          <button class="btn-text" @click="mostrarMiembroRegistrado = false">
            Salir
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Dialog: Realizar Pago -->
    <v-dialog v-model="mostrarRealizarPago" persistent max-width="600">
      <realizar-pago
        :matricula="matricula"
        :miembro="{ inscripcion_pagada: inscripcionYaPagada }"
        @cerrar="cerrarDialogoPago"
        @pagado="onPagado"
      />
    </v-dialog>

    <!-- Credencial -->
    <credencial-miembro
      v-if="mostrarCredencial"
      :matricula="matricula"
      :miembro="miembro"
      @impreso="onImpreso"
    />

    <!-- Loading Overlay -->
    <div v-if="cargando" class="loading-overlay">
      <div class="loading-inner">
        <div class="spinner"></div>
        <p class="loading-text">Registrando miembro…</p>
      </div>
    </div>

    <!-- Snackbar -->
    <v-snackbar
      v-model="mostrarMensaje"
      :timeout="3000"
      :color="mensaje.color"
      top
      right
    >
      <div class="flex items-center gap-md">
        <v-icon color="white">{{ mensajeIcon }}</v-icon>
        <span>{{ mensaje.texto }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small @click="mostrarMensaje = false" v-bind="attrs">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FormMiembro from "./FormMiembro.vue";
import Breadcrumbs from "../Dialogos/Breadcrumbs.vue";
import HttpService from "../../Servicios/HttpService";
import RealizarPago from "./RealizarPago.vue";
import CredencialMiembro from "./CredencialMiembro.vue";

export default {
  name: "NuevoMiembro",
  components: { FormMiembro, Breadcrumbs, RealizarPago, CredencialMiembro },

  data: () => ({
    mostrarMensaje: false,
    mensaje: {
      color: "",
      texto: ""
    },
    miembro: {},
    mostrarMiembroRegistrado: false,
    mostrarRealizarPago: false,
    mostrarCredencial: false,
    matricula: "",
    cargando: false,
    datosMiembro: {
      datosPersonales: {
        nombre: "",
        telefono: "",
        direccion: "",
        edad: 20
      },
      datosContacto: {
        sufreEnfermedad: false,
        tieneSeguro: false,
        enfermedad: "",
        institucion: "",
        nombreContacto: "",
        telefonoContacto: ""
      },
      imagen: null,
      inscripcionYaPagada: false
    }
  }),

  computed: {
    mensajeIcon() {
      switch (this.mensaje.color) {
        case "success":
          return "mdi-check-circle";
        case "error":
          return "mdi-alert-circle";
        case "warning":
          return "mdi-alert";
        default:
          return "mdi-information";
      }
    }
  },

  methods: {
    generarCredencial() {
      HttpService.obtenerConDatos(
        {
          metodo: "obtener_imagen",
          matricula: this.matricula
        },
        "miembros.php"
      ).then(respuesta => {
        this.miembro.imagen = respuesta.imagen;
        this.miembro.fechaRegistro = new Date().toLocaleDateString();
        this.mostrarCredencial = true;
      });
    },

    onImpreso(resultado) {
      this.mostrarCredencial = resultado;
    },

    onRegistrado(miembro) {
      this.miembro = miembro;

      this.inscripcionYaPagada = !!(
        miembro.inscripcion && miembro.inscripcion.monto > 0
      );

      let payload = {
        metodo: "registrar",
        miembro: this.miembro
      };

      console.log(this.miembro);
      this.cargando = true;
      HttpService.registrar(payload, "miembros.php").then(registrado => {
        console.log(registrado);
        if (registrado) {
          this.matricula = registrado;
          this.mostrarMiembroRegistrado = true;
          this.cargando = false;
        }
      });
    },

    realizarPago() {
      this.mostrarMiembroRegistrado = false;
      this.mostrarRealizarPago = true;
    },

    onPagado(resultado) {
      if (resultado) {
        this.mostrarRealizarPago = false;
        this.mostrarMensaje = true;
        this.mensaje = {
          color: "success",
          texto: "Pago realizado con éxito"
        };
      }
    },

    cerrarDialogoPago(resultado) {
      this.mostrarRealizarPago = resultado;
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap");

/* ===== TOKENS ===== */
.nuevo-miembro-page {
  --bg: #0e0e10;
  --card: #17171a;
  --card-border: #26262a;
  --text-primary: #f2f2ed;
  --text-secondary: #8c8c93;
  --text-tertiary: #5c5c62;
  --accent: #c8ff4d;
  --accent-dim: rgba(200, 255, 77, 0.12);
  --error: #ff6b6b;
  --radius: 4px;

  --font-display: "Space Grotesk", sans-serif;
  --font-body: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: "JetBrains Mono", monospace;
}

.nuevo-miembro-page {
  min-height: 100vh;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font-body);
  position: relative;
  padding: 40px;
}

.bg-grid {
  position: fixed;
  inset: 0;
  background-image: linear-gradient(
      rgba(242, 242, 237, 0.02) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(242, 242, 237, 0.02) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
}

.nuevo-miembro-shell {
  position: relative;
  z-index: 1;
  max-width: 860px;
  margin: 0 auto;
}

/* ===== HEADER ===== */
.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 10px;
}

/* Sobreescribimos el componente Breadcrumbs para que respete los tokens.
   Si Breadcrumbs.vue trae su propio estilo con !important, avísame para
   ajustarlo directamente en su archivo. */
.page-header >>> .v-breadcrumbs {
  padding: 0 !important;
}

.page-header >>> .v-breadcrumbs li,
.page-header >>> .v-breadcrumbs__item {
  font-size: 12.5px !important;
  color: var(--text-tertiary) !important;
  font-family: var(--font-body) !important;
}

.page-header >>> .v-breadcrumbs__item--disabled,
.page-header >>> .v-breadcrumbs__item.v-breadcrumbs__item--link {
  color: var(--text-secondary) !important;
}

.page-header >>> .v-breadcrumbs__divider {
  color: var(--text-tertiary) !important;
}

/* ===== MODAL ===== */
.modal-panel {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
}

.modal-head {
  padding: 26px 24px 20px;
  border-bottom: 1px solid var(--card-border);
}

.modal-head-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.modal-status-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
}

.modal-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin: 0;
}

.modal-body {
  padding: 22px 24px;
}

.modal-text-center {
  font-size: 13.5px;
  color: var(--text-secondary);
  text-align: center;
  line-height: 1.6;
  margin: 0 0 18px;
}

.text-accent {
  color: var(--accent);
  font-weight: 600;
}

.info-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 12px 14px;
  font-size: 12.5px;
  color: var(--text-secondary);
  text-align: center;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--card-border);
}

.modal-footer-stack {
  flex-direction: column;
  align-items: stretch;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 11px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover {
  filter: brightness(1.08);
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 11px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

.btn-text {
  background: transparent;
  border: none;
  color: var(--text-tertiary);
  font-size: 12.5px;
  padding: 8px;
  cursor: pointer;
  text-align: center;
  transition: color 0.15s ease;
}

.btn-text:hover {
  color: var(--text-primary);
}

/* ===== LOADING OVERLAY ===== */
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(14, 14, 16, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid var(--card-border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.loading-text {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-secondary);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== MOTION ===== */
.fade-in {
  animation: fadeIn 0.4s ease both;
}

.delay-100 {
  animation-delay: 0.05s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in,
  .spinner {
    animation: none;
  }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .nuevo-miembro-page {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Miembros/NuevoMiembro.vue